module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "signature-wrap"
  }, [(_vm.installState && _vm.browerState && _vm.type != 3) ? _c('div', {
    staticClass: "sig-header"
  }, [_c('div', {
    staticClass: "sig-header-lt"
  }, [(_vm.type == 0 || _vm.type == 2) ? _c('span', [_c('div', {
    staticClass: "sig-btn",
    on: {
      "click": function($event) {
        _vm.predeal('handStamp')
      }
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "sig-btn-name"
  }, [_vm._v("盖章")])]), _vm._v(" "), _c('div', {
    staticClass: "sig-btn",
    on: {
      "click": function($event) {
        _vm.predeal('qiFengSeal')
      }
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "sig-btn-name"
  }, [_vm._v("骑缝")])])]) : _vm._e(), _vm._v(" "), (_vm.type == 0 || _vm.type == 1) ? _c('div', {
    staticClass: "sig-btn-ipt"
  }, [_c('div', {
    staticClass: "sig-btn-lt",
    on: {
      "click": function($event) {
        _vm.predeal('handwrite')
      }
    }
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "sig-btn-name"
  }, [_vm._v("签名")])]), _vm._v(" "), _c('div', {
    staticClass: "sig-btn-rt",
    on: {
      "click": _vm.penColor
    }
  }, [_c('i', {
    staticClass: "epfont ep-icon-banshou"
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "sig-btn  sig-btn-upload",
    on: {
      "click": function($event) {
        _vm.predeal('upload')
      }
    }
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "sig-btn-name"
  }, [_vm._v("提交")])]), _vm._v(" "), _c('div', {
    class: ['sig-btn-giveup', {
      'give-up-active': _vm.giveState
    }],
    on: {
      "click": _vm.giveUp
    }
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "sig-btn-name"
  }, [_vm._v("取消")])])]), _vm._v(" "), _c('div', {
    staticClass: "sig-header-rt"
  }, [_c('div', {
    staticClass: "sig-btn",
    on: {
      "click": function($event) {
        _vm.pageNumber += 20
      }
    }
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "sig-btn-name"
  }, [_vm._v("放大")])]), _vm._v(" "), _c('div', {
    staticClass: "sig-btn",
    on: {
      "click": function($event) {
        _vm.pageNumber -= 20
      }
    }
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "sig-btn-name"
  }, [_vm._v("缩小")])]), _vm._v(" "), _c('div', {
    staticClass: "sig-btn",
    on: {
      "click": _vm.undo
    }
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "sig-btn-name"
  }, [_vm._v("撤销")])]), _vm._v(" "), _c('div', {
    staticClass: "sig-btn",
    on: {
      "click": _vm.redo
    }
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "sig-btn-name"
  }, [_vm._v("恢复")])]), _vm._v(" "), _c('div', {
    staticClass: "sig-btn",
    on: {
      "click": function($event) {
        _vm.predeal('printDoc')
      }
    }
  }, [_vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "sig-btn-name"
  }, [_vm._v("打印")])]), _vm._v(" "), _c('div', {
    staticClass: "sig-btn",
    on: {
      "click": _vm.clearAll
    }
  }, [_vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "sig-btn-name"
  }, [_vm._v("清空")])])])]) : _vm._e(), _vm._v(" "), (!_vm.installState && _vm.browerState) ? _c('div', {
    staticClass: "sig-header sig-install"
  }, [_c('div', {
    staticClass: "sig-btn",
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": _vm.controlInstall
    }
  }, [_vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "sig-btn-name"
  }, [_vm._v("控件安装")])])]) : _vm._e(), _vm._v(" "), (!_vm.browerState) ? _c('div', {
    staticClass: "sig-header"
  }, [_c('div', {
    staticClass: "sig-other-brower"
  }, [_vm._v("\n\t\t\t\t签字盖章操作仅支持在IE浏览器，请切换浏览器再进行此操作！\n\t\t\t")])]) : _vm._e(), _vm._v(" "), _vm._m(12)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sig-btn-icon"
  }, [_c('i', {
    staticClass: "epfont ep-icon-gaizhang"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sig-btn-icon"
  }, [_c('i', {
    staticClass: "epfont ep-icon-qifengzhang"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sig-btn-icon"
  }, [_c('i', {
    staticClass: "epfont ep-icon-bianji"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sig-btn-icon"
  }, [_c('i', {
    staticClass: "epfont ep-icon-group8"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sig-btn-icon"
  }, [_c('i', {
    staticClass: "epfont ep-icon-quxiao"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sig-btn-icon"
  }, [_c('i', {
    staticClass: "epfont ep-icon-fangda"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sig-btn-icon"
  }, [_c('i', {
    staticClass: "epfont ep-icon-suoxiao"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sig-btn-icon"
  }, [_c('i', {
    staticClass: "epfont ep-icon-fanhui"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sig-btn-icon"
  }, [_c('i', {
    staticClass: "epfont ep-icon-chexiao"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sig-btn-icon"
  }, [_c('i', {
    staticClass: "epfont ep-icon-ccgl-dayinliebiao-3"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sig-btn-icon"
  }, [_c('i', {
    staticClass: "epfont ep-icon-shanchu"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sig-btn-icon"
  }, [_c('i', {
    staticClass: "epfont ep-icon-xiazai"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sig-content"
  }, [_c('object', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "id": "HWPostil1",
      "align": "middle",
      "classid": "clsid:FF1FE7A0-0578-4FEE-A34E-FB21B277D561",
      "codebase": "HWPostil.cab#version=3,0,6,6"
    }
  }, [_c('param', {
    attrs: {
      "name": "_Version",
      "value": "65536"
    }
  }), _vm._v(" "), _c('param', {
    attrs: {
      "name": "_ExtentX",
      "value": "17410"
    }
  }), _vm._v(" "), _c('param', {
    attrs: {
      "name": "_ExtentY",
      "value": "10874"
    }
  }), _vm._v(" "), _c('param', {
    attrs: {
      "name": "_StockProps",
      "value": "0"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-387eb8db","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/iexplore/components/signature/src/Signature.vue
// module id = 1211
// module chunks = 2